import PropTypes from "prop-types";
import React, { useState } from "react";
import Heading from "../../elements/heading";
import Input from "../../elements/input";
import BodyText from "../../elements/body-text";
import "./style.scss";
import { SuperButton } from "../../elements";

const SetNewPasswordForm = ({ headingType, headingBody, body, passwordLabel, passwordInfoMessage, passwordWarningMessage, passwordMissingMessage, submitButton, submitNewPassword, serverError, disclaimer }) => {
  const [formDataPassword, setPassword] = useState();
  const [passwordError, setPasswordError] = useState(null);
  const [passwordValidationHasError, setPasswordValifdationHasError] = useState(false);

  const onPasswordChange = (evt, isValid) => {
    setPassword(evt.target.value);
    setPasswordValifdationHasError(!isValid);
  };

  const onPasswordHasFocus = () => {
    setPasswordError(null);
  };
  const onPasswordBlur = () => {
    if (passwordValidationHasError) {
      setPasswordError(passwordWarningMessage.value);
    }
  };

  const onSubmit = evt => {
    evt.stopPropagation();
    evt.preventDefault();

    if (!formDataPassword) {
      setPasswordError(passwordMissingMessage.value);
      return;
    }
    if (passwordValidationHasError) {
    } else {
      const formData = { password: formDataPassword };
      submitNewPassword(evt, formData);
    }
  };
  return (
    <form className="set-new-password-form">
      {headingType && headingBody && <Heading type={headingType} className="title show-on-scroll" html={headingBody} typographyClass="type-h3" />}

      {passwordLabel && (
        <Input
          {...{
            type: "password",
            label: passwordLabel.value,
            infoMessage: passwordInfoMessage.value,
            warningMessage: passwordError,
            showError: passwordError !== null,
            onChange: (evt, isValid) => onPasswordChange(evt, isValid),
            onFocus: evt => onPasswordHasFocus(evt),
            onBlur: evt => onPasswordBlur(evt)
          }}
        />
      )}

      {serverError && serverError.hasError && serverError.message && <span className="failed-message">{serverError.message}</span>}

      <div className="button-container">{submitButton && <SuperButton {...{ ...submitButton, callback: evt => onSubmit(evt) }} />}</div>

      {body && <BodyText html={body.value} className="disclaimer" />}
    </form>
  );
};

SetNewPasswordForm.propTypes = {
  heading: PropTypes.object,
  password: PropTypes.object,
  submitButton: PropTypes.object,
  submitNewPassword: PropTypes.func,
  serverError: PropTypes.shape({
    hasError: PropTypes.bool,
    message: PropTypes.string
  }),
  disclaimer: PropTypes.shape({
    showCheckbox: PropTypes.bool,
    termsCheckbox: PropTypes.any,
    body: PropTypes.any
  })
};

SetNewPasswordForm.defaultProps = {
  submitNewPassword: () => {},
  disclaimer: { body: "" }
};

export default SetNewPasswordForm;
